import PropTypes from "prop-types";
import React, { useEffect, Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { multilanguage, loadLanguages } from "redux-multilanguage";
import { connect } from "react-redux";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";

// home pages
const HomeOrganicFood = lazy(() => import("./pages/home/HomeOrganicFood"));

 

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>import("./pages/blog/BlogDetailsStandard"));


// Brands 
const ProductDetails = lazy(() =>import("./pages/brands/beverage/productDetails")); 


// About 
const ChairmanMessage = lazy(() => import('./pages/about/chairmanMessage'))
const GivingBack = lazy(() => import('./pages/about/givingBack')) 
const Mission = lazy(() => import('./pages/about/mission'))
const OurValues = lazy(() => import('./pages/about/ourValues'))
const Subscriber = lazy(() => import('./pages/about/subscriber'))
// 


// 
// Careers 
const WhyShaheen = lazy(() => import('./pages/careers/whyShaheen'))
const JobOpening = lazy(() => import('./pages/careers/jobOpening'))
// 

// media 
const Events = lazy(() => import('./pages/media/events'))
const Gallery = lazy(() => import('./pages/media/gallery'))
const LastestNews = lazy(() => import('./pages/media/lastestNews'))
// 


// FAQ 
const AskShaheen = lazy(() => import('./pages/faq/askShaheen'))
const FewFaq = lazy(() => import('./pages/faq/fewFaq'))
const PrivacyPolicy = lazy(() => import('./pages/faq/privacyPolicy'))
// 


// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = (props) => {
  useEffect(() => {
    props.dispatch(
      loadLanguages({
        languages: {
          en: require("./translations/english.json"),
          fn: require("./translations/french.json"),
          de: require("./translations/germany.json")
        }
      })
    );
  });


  return (
    <ToastProvider placement="bottom-left">
      <BreadcrumbsProvider>
        <Router>
          <ScrollToTop>
            <Suspense
              fallback={
                <div className="flone-preloader-wrapper">
                  <div className="flone-preloader">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              }
            >
              <Switch>
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={HomeOrganicFood}
                />




                {/* About */}
                  <Route path={process.env.PUBLIC_URL + "/chairman-message"} component={ChairmanMessage} />
                  <Route path={process.env.PUBLIC_URL + "/mission-vision"} component={Mission}/>
                  <Route path={process.env.PUBLIC_URL + "/our-values"} component={OurValues}/>
                  <Route path={process.env.PUBLIC_URL + "/giving-back"} component={GivingBack}/>
                  <Route path={process.env.PUBLIC_URL + "/subscribe"} component={Subscriber}/>
                {/*  */}

                {/* Brands */}
                <Route path={process.env.PUBLIC_URL + "/brands/:productCat/:product/:productid"} component={ProductDetails} />

                {/*  */}

                {/* Careers */}
                  <Route path={process.env.PUBLIC_URL + "/why-Shaheen"} component={WhyShaheen} />
                  <Route path={process.env.PUBLIC_URL + "/job-Opening"}component={JobOpening}/>
                {/*  */}


                {/* Media */}
                  <Route path={process.env.PUBLIC_URL + "/events"} component={Events} />
                  <Route path={process.env.PUBLIC_URL + "/lastest-News"}component={LastestNews}/>
                  <Route path={process.env.PUBLIC_URL + "/gallery"}component={Gallery}/>
                {/*  */}

                
                {/* FAQ */}
                  <Route path={process.env.PUBLIC_URL + "/ask-shaheen"} component={AskShaheen} />
                  <Route path={process.env.PUBLIC_URL + "/faq"} component={FewFaq}/>
                  <Route path={process.env.PUBLIC_URL + "/privacy-policy"}component={PrivacyPolicy}/>
                {/*  */}

                {/* Shop product pages */}
                <Route
                  path={process.env.PUBLIC_URL + "/product/:id"}
                  render={(routeProps) => (
                    <Product {...routeProps} key={routeProps.match.params.id} />
                  )}
                />

                {/* Blog pages */}
                <Route
                  path={process.env.PUBLIC_URL + "/blog-standard"}
                  component={BlogStandard}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
                  component={BlogNoSidebar}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
                  component={BlogRightSidebar}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/blog-details-standard"}
                  component={BlogDetailsStandard}
                />





                {/* Other pages */}
                <Route
                  path={process.env.PUBLIC_URL + "/about"}
                  component={About}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/contact"}
                  component={Contact}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/my-account"}
                  component={MyAccount}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/login-register"}
                  component={LoginRegister}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/cart"}
                  component={Cart}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/wishlist"}
                  component={Wishlist}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/compare"}
                  component={Compare}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/checkout"}
                  component={Checkout}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/not-found"}
                  component={NotFound}
                />

                <Route exact component={NotFound} />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </Router>
      </BreadcrumbsProvider>
    </ToastProvider>
  );
};

App.propTypes = {
  dispatch: PropTypes.func
};

export default connect()(multilanguage(App));



